module.exports = __webpack_public_path__ + "img/14_ryan-ancill.774eabcd.jpg";